import React, { useMemo } from 'react';
import { MCButton, MCText, SearchTextField, View } from 'src/components/basic';
import { rgba, scssVariables as variables, convertMobileStyle, lang } from 'src/helpers';

import { remCss, remFontCss } from 'src/components/mobile/utils';
import LANG_CONST from 'src/helpers/lang/const';
import SVGIcon from 'src/components/svg';
import { ScrollDrag } from '../complex';
import { FlexFitWidth } from '../basic/FlexFitWidth';

const styles = {
  categoryContainer: {
    backgroundColor: variables['colors-mc-white'],
    borderWidth: 1,
    borderColor: variables['colors-mc-border2'],
    borderStyle: 'solid',
    borderRadius: remCss(10),
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    marginEnd: remCss(10),
    padding: remCss(15),
    display: 'flex',
    cursor: 'pointer',
    gap: remCss(10)
  },
  categoryIcon: {
    backgroundColor: rgba(variables['colors-mc-primary'], 0.1),
    borderRadius: remCss(60),
    width: remCss(60),
    borderColor: variables['colors-mc-primary'],
    borderWidth: 1
  },
  categoryIconActive: {
    backgroundColor: variables['colors-mc-white'],
    borderColor: variables['colors-mc-secondary2']
  },
  categoryActive: {
    backgroundColor: variables['colors-mc-primary'],
    borderColor: variables['colors-mc-primary']
  }
};
export const AllCategories = ({ specialist, onClick }) => {
  const [categorySearch, setCategorySearch] = React.useState('');
  const list = useMemo(() => {
    let nextList = [...(specialist || [])].sort((a, b) => {
      return a > b ? 1 : -1;
    });
    if (categorySearch.toString().length > 0) {
      nextList = nextList.filter(
        (s) =>
          lang
            .t(LANG_CONST.constants.specialist[s])
            .toLowerCase()
            .indexOf(categorySearch?.toLowerCase()) > -1
      );
    }
    return nextList;
  }, [categorySearch, specialist]);

  return (
    <View>
      <View style={{ paddingHorizontal: remCss(15), paddingBottom: remCss(15) }}>
        <SearchTextField
          template={'2'}
          placeholder={'Search'}
          onChange={setCategorySearch}
          value={categorySearch}
        />
      </View>
      <FlexFitWidth itemWidth={150} gap={10} padding={15}>
        {list?.map((s) => {
          return (
            <button
              key={s}
              onClick={(e) => {
                e.preventDefault();
                onClick(s);
              }}
              style={convertMobileStyle(styles.categoryContainer)}
            >
              <View style={convertMobileStyle(styles.categoryIcon)}>
                <SVGIcon iconname={s + '-icon'} width={remCss(60)} height={remCss(60)} />
              </View>
              <MCText
                size={remFontCss(16)}
                weight={500}
                label={LANG_CONST.constants.specialist[s]}
              />
            </button>
          );
        })}
      </FlexFitWidth>
    </View>
  );
};

export const CategoriesHorizontal = ({ specialist, selected = [], onSelect, onViewAll }) => {
  let list = specialist.sort((a, b) => {
    if (selected.includes(a) && !selected.includes(b)) return -1;
    if (!selected.includes(a) && selected.includes(b)) return 1;
    return a > b ? 1 : -1;
  });
  return (
    <View
      style={{
        paddingHorizontal: remCss(15),
        gap: remCss(15),
        backgroundColor: rgba(variables['colors-mc-primary'], 0.05)
      }}
    >
      <ScrollDrag style={{ gap: remCss(10) }}>
        {list?.map((s) => {
          let active = selected.indexOf(s) > -1;
          return (
            <button
              key={s}
              onClick={(e) => {
                e.preventDefault();
                onSelect(s);
              }}
              style={convertMobileStyle({
                minWidth: remCss(100),
                width: remCss(100),
                maxWidth: remCss(100),
                ...styles.categoryContainer,
                ...(active ? styles.categoryActive : {})
              })}
            >
              <View
                style={convertMobileStyle({
                  ...styles.categoryIcon,
                  ...(active ? styles.categoryIconActive : {})
                })}
              >
                <SVGIcon iconname={s + '-icon'} width={remCss(60)} height={remCss(60)} />
              </View>
              <MCText
                size={remFontCss(16)}
                numberOfLines={1}
                weight={500}
                white={active}
                label={LANG_CONST.constants.specialist[s]}
              />
            </button>
          );
        })}
      </ScrollDrag>
      <View
        style={{
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          paddingBottom: remCss(15)
        }}
      >
        <MCText label={LANG_CONST.titles.categories} size={remFontCss(20)} weight={500} />
        <MCButton
          primary
          radius
          medium
          dark
          label={LANG_CONST.buttons.view_all}
          onClick={onViewAll}
        />
      </View>
    </View>
  );
};
